import { render, staticRenderFns } from "./FilterItemCategories.vue?vue&type=template&id=8ce96bd4&"
import script from "./FilterItemCategories.vue?vue&type=script&lang=js&"
export * from "./FilterItemCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports